import { Injectable, Inject } from "@angular/core";
import { AppConfig } from "src/environments/appconfig";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { ParametroPaginacionGenerico } from "src/app/util/ParametroPaginacionGenerico";
import { DtoLineaCredito } from "../dominio/DtoLineaCredito";
import { JsonPipe } from "@angular/common";
import { UHttpsClient } from "../../../../seguridad/seguridad/uhttpsClient";

@Injectable()
export class ClientemastServicio {

    private url = `${this.config.getEnv('proxy')}spring/core/clientemast/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public obtenerLineaCredito(cliente: number): Promise<DtoLineaCredito> {
        const params = new HttpParams().set('cliente', JSON.stringify(cliente));
        return this.http.get(`${this.url}obtenerLineaCredito`, { params,headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoLineaCredito;
            })
            .catch(error => new DtoLineaCredito());
    }
}

